import React from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const NewsRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/news/events');
  }, [])
  return (
    <div></div>
  )
}

export default NewsRedirect